import React from "react"
import { ToolTip } from "../components/utils/ToolTip"

export const Yeat = () => {

    const CONFIG_MAX_WIDTH = { maxWidth: '1024px' }

    return (
        <React.Fragment>
            <div className="wrapper md:align-middle align-baseline w-full overflow-auto md:h-screen h-auto text-sm text-stone-600">
                <section className="md:h-screen rounded-md w-full lg:max-w-[1024px] md:w-full flex items-center justify-center ">
                    <div className="flex md:flex-row flex-col align-middle items-center w-full md:pb-0 pb-10">

                        {/* Small Section */}
                        <div className="lg:basis-2/5 md:basis-1/3 md:flex flex-col md:h-screen bg-orange-">
                            <div className="h-8 w-full flex flex-row-reverse flex-none">
                                <button type="button" className="md:hidden flex flex-col align-middle justify-center rounded-md text-gray-800 dark:text-gray-200 hover:text-gray-800 focus:outline-none w-8 h-full"
                                    onClick={undefined}>
                                    <span className="fas fa-times border-none text-lg"></span>
                                    <span className="sr-only text-sm ml-3">Close panel</span>
                                </button>
                            </div>

                            <div className="w-full md:flex-grow py-3 px-4">
                                <span className="block text-xl md:text-2xl">
                                    Secure Your Account

                                    <span className="text-sm pt-4 pb-2 text-stone-600 block">
                                        Add your phone number for secure cash withdrawals and easy contact in case of issues.
                                    </span>
                                </span>
                            </div>

                            <div className="w-full px-2 pb-5">
                                {
                                        <button type="button" className="text-sm flex-none shadow-none px-3 py-1 bg-inherit text-slate-600 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 hover:underline hover:cursor-pointer mr-2 sm:w-auto sm:text-sm" onClick={undefined}>
                                            Cancel
                                        </button>
                                }
                            </div>
                        </div>

                        {/* Large Section */}
                        <div className="lg:basis-3/5 md:basis-3/4 md:flex flex-col md:h-screen">
                            <div className="h-8 w-full flex-none flex flex-row-reverse"></div>

                            <div className="w-full md:flex flex-col flex-grow pt-3 px-5">
                                <div className="flex-none w-32 md:float-start float-right">
                                    <div className="w-full py-3 grid grid-cols-3 gap-x-2">
                                        <div className="rounded-md h-2 shadow-lg bg-orange-600"></div>
                                        <div className="rounded-md h-2 shadow-lg bg-orange-400"></div>
                                        <div className="rounded-md h-2 shadow-lg bg-slate-400"></div>
                                    </div>

                                    <span className="text-sm text-stone-500 md:text-start text-right block">
                                        2 of 3
                                    </span>
                                </div>

                                <div className="md:flex-grow w-full pt-3">
                                    <h3 className="text-sm pb-2 font-semibold text-slate-600 dark:text-slate-300 uppercase tracking-wide">
                                        Authentication Provider
                                    </h3>

                                    <span className="flex gap-x-3 align-middle items-center bg-sky-300 text-base text-slate-800 dark:text-slate-200">
                                        Authentication Provider

                                        <ToolTip
                                            position={'right'}
                                            tooltipsText={'Decide how this account should authenticate'}
                                            icon={
                                                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                                    <g id="SVGRepo_iconCarrier">
                                                        <circle cx="12" cy="12" r="10" stroke="#1C274C" strokeWidth="1.5"></circle>
                                                        <path d="M12 17V11" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"></path>
                                                        <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="#1C274C"></circle>
                                                    </g>
                                                </svg>
                                            }
                                        />
                                    </span>
                                </div>
                            </div>

                            <div className="flex-none w-full pb-5 flex flex-row-reverse gap-x-3 align-middle">
                                <button className="bg-orange-600 float-right relative min-w-28 py-1.5 px-4 border border-transparent text-sm rounded-md text-white hover:bg-orange-700 focus:outline-none focus:ring-0 focus:ring-offset-2 focus:bg-orange-700" type="submit">
                                    <div className="flex justify-center align-middle items-center gap-x-3">
                                        Next
                                        <i className="fa-regular fa-chevron-right fa-lg"></i>
                                    </div>
                                </button>

                                <button className="text-orange-600 float-right relative min-w-28 py-1.5 px-4 border border-transparent text-sm rounded-md hover:bg-orange-100 focus:outline-none focus:ring-0 focus:ring-offset-2 focus:bg-orange-100" type="submit">
                                    <div className="flex justify-center align-middle items-center gap-x-3">
                                        <i className="fa-regular fa-chevron-left fa-lg"></i>
                                        Previous
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </React.Fragment>
    )
}